
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useParams } from "react-router";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Tab, Tabs, ToggleButton, ToggleButtonGroup } from "@mui/material";

import { TabPanel, TabProps } from "../../../helpers/TabPanel";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { InfoField } from "../../../components/InfoField";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxInformacionAmparo } from "../../../components/BoxInformacionAmparo";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionIrregular } from "../../../components/BoxInformacionIrregular";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { ActualizarEstatus, DetalleNotificacion } from "../../../connections/notificaciones/NotificacionConnection";

import { defaultNotificacion, NotificacionProps } from "../../../interfaces/notificaciones/NotificacionesInterface";

export const VisualizarNotificacionPage = () => {

    const { Id } = useParams();

    const [value, setValue] = useState( 0 );
    const [valueDocumento, setValueDocumento] = useState( 'documento' );

    const dispatch = useDispatch();

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [notificacion, setNotificacion] = useState<NotificacionProps>( defaultNotificacion );

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => { setValue( newValue ); }

    const handleChangeDocumento = ( _: React.MouseEvent<HTMLElement>, newValue: string | null ) => { if ( newValue !== null ) { setValueDocumento( newValue ); } }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        const params = {
            id: Id ?? '',
            idEstatus: 54,
            cancelarBoleta: notificacion.cancelarBoleta,
            motivoCancelacionBoleta: notificacion.motivoCancelacionBoleta,
            cancelarNotificacion: notificacion.cancelarNotificacion,
            turnarCentralActuarios: notificacion.turnarCentralActuarios,

        };

        await ActualizarEstatus( params ).then(resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario } = resp;

                if ( success ) {

                    setOpenDialogConfirmacionFinalizar( false );

                    if ( !asignadoMismoUsuario ) {
                        setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                        setProcesoTerminado( true );
                        setLoading( false );
                    }
                    else if ( asignadoMismoUsuario ) {
                        setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                        setProcesoTerminado( true );
                        setLoading( false );
                    }

                    setLoadingFinalizar( false );
                    setLoading( false );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function obtener() {

            setLoading( true );

            await DetalleNotificacion( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setNotificacion( resp );

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario && resp.turnarCentralActuarios ) {
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ resp.usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 29 ) {
                            setMensajeAsignacion( 'La siguiente actividad se encuentra en tu bandeja' );
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 29 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );
                    }

                }, 700);

            });

        }

        if ( Id ) {
            obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={[ { text: 'Notificación' }, { text: 'Visualizar notificación' } ]} backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                ?
                    procesoNoEncontrado
                    ?
                        <BoxProcesoNoEncontrado />
                    :
                        procesoCancelado
                        ?
                            <BoxProcesoCancelado />
                        :
                            <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ notificacion.idEstatus === 3 } />
                :
                    loading
                    ?
                        <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                            <CircularProgressIndicator />
                        </Box>
                    :
                        <>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                <Tabs value={ value } onChange={ handleChange }>

                                    <Tab label="Notificación" {...TabProps(0)} />
                                    
                                    <Tab
                                        label="Información del amparo"
                                        sx={{ display: notificacion.idAmparo !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(1)}
                                    />

                                    <Tab
                                        label="Información del expediente"
                                        sx={{ display: notificacion.idExpediente !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(2)}
                                    />

                                    <Tab
                                        label="Información del exhorto"
                                        sx={{ display: notificacion.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(3)}
                                    />

                                    <Tab
                                        label="Información del irregular"
                                        sx={{ display: notificacion.idIrregular !== 0 ? 'flex' : 'none' }}
                                        {...TabProps(4)}
                                    />

                                </Tabs>

                            </Box>

                            <TabPanel value={ value } index={ 0 }>

                                <Box p={ 4 } component={ Paper }>

                                    <BoxHeaderInformacion
                                        numeroSeguimiento={ `GNT-${notificacion.idNotificacion}` }
                                        fecha={ new Date() }
                                        numeroBoleta={ notificacion.numeroBoleta } 
                                    />

                                    <Grid container spacing={ 3 } mt={ 3 }>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Persona a notificar"
                                                value={ notificacion.personaNotificar + ' (' + notificacion.tipoParte + ')' }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Domicilio a notificar"
                                                value={ notificacion.domicilioNotificar }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Tipo de notificación"
                                                value={ notificacion.tipoNotificacion + ' (' + notificacion.formaNotificacion + ')' }
                                            />

                                        </Grid>

                                        {
                                            notificacion.numeroBoleta === ""
                                            &&
                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <InfoField
                                                        chip
                                                        label="¿Desea cancelar la notificación?"
                                                        value={ notificacion.cancelarNotificacion ? 'Sí' : 'No' }
                                                    />

                                                </Grid>
                                        }
                                        
                                        {
                                            notificacion.cancelarBoleta
                                            &&
                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <InfoField
                                                        chip
                                                        label="Motivo de cancelación de la boleta"
                                                        value={ notificacion.motivoCancelacionBoleta }
                                                    />

                                                </Grid>
                                        }

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <ToggleButtonGroup
                                                fullWidth
                                                exclusive
                                                color="primary"
                                                size="small"
                                                value={ valueDocumento }
                                                onChange={ handleChangeDocumento }
                                                sx={{ mb: 2 }}
                                            >
                                                <ToggleButton value="documento">Cédula de notificación</ToggleButton>
                                                <ToggleButton value="acuerdo">{ notificacion.tipoOficio ? 'Oficio a notificar' : 'Acuerdo a notificar' }</ToggleButton>
                                            </ToggleButtonGroup>

                                            <iframe
                                                title='iframe-documento'
                                                style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                src={ valueDocumento === 'documento' ? notificacion.documento : notificacion.acuerdo }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                            <Grid container spacing={3}>

                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}> </Grid>

                                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>
                                                    <Button
                                                        fullWidth
                                                        color='primary'
                                                        variant="contained"
                                                        onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                    >
                                                        Finalizar
                                                    </Button>
                                                </Grid>

                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Box>

                            </TabPanel>

                            <TabPanel value={ value } index={ 1 }>

                                <BoxInformacionAmparo amparo={ notificacion.amparo } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 2 }>

                                <BoxInformacionExpediente expediente={ notificacion.expediente } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 3 }>

                                <BoxInformacionExhortoRecibido exhortoRecibido={ notificacion.exhortoRecibido } />

                            </TabPanel>

                            <TabPanel value={ value } index={ 4 }>

                                <BoxInformacionIrregular irregular={ notificacion.irregular } />

                            </TabPanel>
                            
                        </>
            }

            <Dialog
                fullWidth
                maxWidth='xs'
                open={ openDialogConfirmacionFinalizar }
                onClose={ () => { } }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <DialogContentText>
                        ¿Desea finalizar la generación de la notificación?
                    </DialogContentText>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                </DialogActions>
            </Dialog>

        </Layout>
    )
}
